import { Spinner } from './icons'

/** Het scherm tussen "link gescand" en "feest opgehaald". */
export function LoadingScreen({ label = 'Even geduld…' }: { label?: string }) {
  return (
    <main className="flex min-h-full flex-col items-center justify-center gap-4" aria-busy="true">
      <Spinner className="text-accent size-7" />
      <p className="text-ink-faint text-sm">{label}</p>
    </main>
  )
}
